import { inject, Injectable } from '@angular/core';

import { Customer } from '../../../../model/customer.model';
import { RetailCrmNewAccountInput } from '../../model/requests/accounts.model';
import { RetailCrmCustomerFieldsRequestModelMapper } from './customer-fields-model.mapper';

@Injectable({
  providedIn: 'root',
})
export class RetailCrmNewCustomerRequestBodyMapper {
  private readonly customerFieldModelMapper = inject(RetailCrmCustomerFieldsRequestModelMapper);

  /**
   * Map a new customer to the data format accepted by the CRM endpoint
   */
  mapNewAccount(customer: Customer): RetailCrmNewAccountInput {
    const salutation = customer.salutation;
    const firstName = customer.firstName;
    const lastName = customer.lastName;
    const personEmail = customer.privateContact.email;

    if (!salutation || !firstName || !lastName || !personEmail) {
      throw new Error(
        `#CDFTF0043 Failed mapping Customer to RetailCrmNewAccountInput, as required fields are undefined.\n` +
          `Required fields:\n` +
          `  salutation: ${salutation}\n` +
          `  firstName: ${firstName}\n` +
          `  lastName: ${lastName}\n` +
          `  personEmail: ${personEmail}\n`,
      );
    }

    return {
      businessAddressCity: customer.businessContact.address?.city,
      businessAddressCountry: customer.businessContact.address?.country,
      businessAddressComplement: customer.businessContact.address?.addressLine1,
      businessAddressLine2: customer.businessContact.address?.addressLine2,
      businessAddressPostBox: customer.businessContact.address?.postBox,
      businessAddressPostalCode: customer.businessContact.address?.postalCode,
      businessAddressStreet: customer.businessContact.address?.street,
      businessAddressStreetNumber: customer.businessContact.address?.houseNumber,
      businessAddressState: customer.businessContact.address?.province,
      emailBusiness: customer.businessContact.email,
      phoneBusiness: customer.businessContact.phone,
      mobilePhoneBusiness: customer.businessContact.mobile,
      firstName: firstName,
      middleName: customer.middleName,
      lastName: lastName,
      suffix: customer.suffix,
      correspondenceLanguage: customer.correspondenceLanguage?.toLowerCase(),
      phone: customer.privateContact.phone,
      personMobilePhone: customer.privateContact.mobile,
      personEmail: personEmail,
      privateAddressCity: customer.privateContact.address?.city,
      privateAddressCountry: customer.privateContact.address?.country,
      privateAddressComplement: customer.privateContact.address?.addressLine1,
      privateAddressLine2: customer.privateContact.address?.addressLine2,
      privateAddressPostBox: customer.privateContact.address?.postBox,
      privateAddressPostalCode: customer.privateContact.address?.postalCode,
      privateAddressStreet: customer.privateContact.address?.street,
      privateAddressStreetNumber: customer.privateContact.address?.houseNumber,
      privateAddressState: customer.privateContact.address?.province,
      salutation: this.customerFieldModelMapper.mapToRetailCrmSalutation(customer.salutation),
      title: this.customerFieldModelMapper.mapToRetailCrmTitle(customer.title),
      nationalId1: customer.nationalId1,
      nationalId1DocumentType: this.customerFieldModelMapper.mapToNationalIdDocumentType(
        customer.nationalId1DocumentType,
      ),
      taxNumber: customer.taxNumber,
      taxNumberCountry: customer.taxNumberCountry,
    };
  }
}
